/** The two glyphs `/nagrania` draws, from its mockup (variant A), in the house stroke style. */

interface GlyphProps {
  readonly className?: string;
}

const STROKE = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
  focusable: false,
} as const;

/** „Wszyscy klienci": two people, the nearer one whole. */
export function PeopleGlyph({ className }: GlyphProps) {
  return (
    <svg className={className} {...STROKE} strokeWidth={1.7}>
      <circle cx="9" cy="8" r="3.5" />
      <path d="M2.5 20c.6-3.6 3.3-6 6.5-6s5.9 2.4 6.5 6" />
      <path d="M16 4.6a3.5 3.5 0 0 1 0 6.8" />
      <path d="M18.5 14.5c1.7.8 2.8 2.9 3 5.5" />
    </svg>
  );
}

/** „Karta klienta ↗": out of this screen, to the client's card. */
export function OutGlyph({ className }: GlyphProps) {
  return (
    <svg className={className} {...STROKE} strokeWidth={2}>
      <path d="M7 17 17 7M9 7h8v8" />
    </svg>
  );
}
